export const decodeUrl = (url: string) => {
  return decodeURIComponent(url);
};
